import React from 'react'

const Iceberg = ({orderType}) => {
  return (
    <div>
      
    </div>
  )
}

export default Iceberg
